import { endpoints as dataEndpoints } from '@/project/data/endpoints'

export const endpoints = {
  ...dataEndpoints,
}
